import { has } from 'lodash';
import { getType } from 'typesafe-actions';

import { updateLoading } from '../actions';
import { PREFIX, SUFFIX_ERROR, SUFFIX_REQUEST, SUFFIX_SUCCESS } from '../actions/actionTypes';

const initialState = false;

export default function createLoadingReducer() {
  return (state = initialState, action: any) => {
    if (action.type === getType(updateLoading)) {
      return action.payload;
    }

    const { type, skipSpinner } = action;

    // Handle legacy actions
    if (has(action, 'loading')) {
      return action.loading;
    }
    if (/_SUCCESS|_ERROR/.test(action.type)) {
      return false;
    }
    if (type.indexOf(PREFIX) === 0) {
      if (type.indexOf(SUFFIX_REQUEST) > 0 && !skipSpinner) {
        return true;
      }
      if (type.indexOf(SUFFIX_SUCCESS) > 0 || type.indexOf(SUFFIX_ERROR) > 0) {
        return false;
      }
    }
    return state;
  };
}
